var folder = "echosdesmontagnes/"
var cldFolder = "https://res.cloudinary.com/eclimontessori/image/upload/"


function imageFullRes(w){
  var newtransf = "fl_progressive,c_scale,w_"+w;

  //get all image in img tag
  $("img").each(function(){
    var src = $(this).attr("src");
    var ext = src.split(".").slice(-1)[0];
    if(ext==="jpg"||ext==="png"){
      var urlarr = src.split("/")
      var transformation = src.split("/")[6];

      if ($(this).hasClass("img--small")){

      }else if ($(this).hasClass("img--medium")){
        urlarr[6]="c_scale,w_500";
        $(this).attr("src",urlarr.join('/'))
      }else if ($(this).hasClass("img--half") && w > 769) {
        width = Math.round(w/2);
        urlarr[6]="c_scale,w_"+width;
        $(this).attr("src",urlarr.join('/'))
      }else if ($(this).hasClass("img--hcrop") && w > 769) {
        urlarr[6]="c_lfill,h_350,w_530";
        $(this).attr("src",urlarr.join('/'))
      }else{
        urlarr[6]=newtransf;
        $(this).attr("src",urlarr.join('/'))
      }
    }
  })

  if (w < 967) {
    var newtransfback = "fl_progressive,c_scale,h_500";
  }else{
    var newtransfback = "fl_progressive,c_scale,w_"+w;
  }

  $(".background-img").each(function(){
    var imgsrc = $(this).attr("backimg");
    var urlFull = cldFolder + newtransfback +"/"+ folder +imgsrc;
    $(this).css("background-image","url("+urlFull+")")
  })
}



function getAppropriateRes(callback){
  var docwidth = $(document).width();
  callback(docwidth)
}

module.exports = function () {
  $(document).ready(function(){
    getAppropriateRes(imageFullRes)

  })
}



//////////////////
// WEBPACK FOOTER
// ./app/shared/js/images.js
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 8